/* @flow */
import enumerate from 'lib/enumerate';

export const PromptNames = {
  NUX_SETUP_CLASS: 'nux_setup_class',
  NUX_START_NEW_CHAT_TOOLTIP: 'nux_start_new_chat_tooltip',
  NUX_MORE_SIDEBAR_TOOLTIP: 'nux_more_sidebar_tooltip',
  NUX_SETUP_SIGNATURE: 'nux_setup_signature',
  NUX_SETUP_FIRST_SUBSCRIPTION: 'nux_setup_subscription',
  NUX_SETUP_SMS_DEVICE: 'nux_setup_sms_device',
  INVITE_DIALOG_CONFIRM_HIDE: 'invite_dialog_confirm_hide',
  DESKTOP_NOTIFICATION_MODAL: 'desktop_notification_modal_web',
  SAFETY_MODAL: 'safety_modal',
  SP_CREATE_GROUP_MODAL: 'snp_create_group',
  ADMIN_VERIFIED_MODAL: 'admin_verification_accepted_modal',
  ADMIN_REJECTED_MODAL: 'admin_verification_rejected_modal',
  ADMIN_PREVERIFIED_MODAL: 'admin_preverified_modal',
  MESSAGE_HISTORY_MODAL: 'message_history',
  ACTIVITIES_BANNER: 'june_2016_activities_banner',
  NUX_CHAT_THREAD: '2016.aug.new_user_experience',
  TYMK_MODAL: '6.11.tymk_modal',
  TYMK_BADGE: '6.11.tymk_badge',
  PDF_CALLOUT: 'pdf_callout_prompt',
  LONG_ANNOUNCEMENTS_BANNER: 'web_show_long_announcements_banner',
  TEACHER_INFO_COLLECTION: 'teacher_info_collection',
};

export const ActionTypes = enumerate([
  'PROMPT_DISMISSED',
  'EXISTING_PROMPT_DISMISSED',
  'USER_PROMPT_DISMISSED',
]);



// WEBPACK FOOTER //
// ./src/constants/PromptConstants.js